const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');

const modal = ({ handlers }) => {

    return (
        <OKModal
            description="mortgageRequestPanel-dataProprietorModalBody"
            footerType="navigation"
            isOpen={true}
            onCloseCallback={handlers.handleModalClose}
            onPrimaryButtonClick={handlers.handleClickBtn}
            onSecondaryButtonClick={handlers.handleModalClose}
            primaryButtonText="mortgageRequestPanel-dataProprietorModalBtnDelete"
            secondaryButtonText="common-cancel"
            title="mortgageRequestPanel-dataProprietorModalTitle"
        />
    )
};

modal.propTypes = {
    handlers: PropTypes.object
};

module.exports = modal;
